import Vue from 'vue'
import md5 from 'js-md5'
const axios = require('axios')
// const env = '/qingzhouApi/index.php/' // 测试
const env = '/api/index.php/' // 生产
const api = {
  /*
  * 微信签名
  */
  signatureRead: env + 'service/Wechat/get_signature',
  // 配置
  webConfigsRead: env + 'content/Configs/read',
  webConfigsFind: env + 'content/Configs/find',
  //  网站管理 观点
  webInsightRead: env + 'content/Insight/read',
  webInsightFind: env + 'content/Insight/find',
  webInsightPull: env + 'content/Insight/pull',
  // 作品
  webWorksRead: env + 'content/Works/read',
  webWorksFind: env + 'content/Works/find',
  webWorksPull: env + 'content/Works/pull'
}

/*
* 生成签名
*/
const getSignature = function () {
  let port = '787720'
  let key = '7829103092'
  let value = '7c28d32a71ebd416'
  let timestamp = Date.parse(new Date()).toString().substr(0, 10)
  let sign = md5(timestamp + key + value).toUpperCase()
  axios.defaults.headers.common['SIGN'] = sign
  axios.defaults.headers.common['AUTHID'] = port
  axios.defaults.headers.common['TIMESTAMP'] = timestamp
}

/**
 * Get请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 */
Vue.prototype.get = function (param, callback) {
  getSignature()
  let query = param.data ? param.data : {}
  axios.get(api[param.url], {
    params: query
  }).then((res) => {
    callback(res.data)
  }).catch((err) => {
    const res = {
      code: 0,
      data: '',
      msg: err.message
    }
    callback(res)
  })
}

/*
* POST请求
*/
Vue.prototype.post = function (param, callback) {
  getSignature()
  let query = param.data ? param.data : {}
  axios.post(api[param.url], {
    params: query
  }).then((res) => {
    callback(res.data)
  }).catch((err) => {
    const res = {
      code: 0,
      data: '',
      msg: err.message
    }
    callback(res)
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js